import { useContext } from 'react';
import { IconButton } from 'src/components/Buttons';
import { useContent } from 'src/contexts/ContentContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { vars } from 'src/core/themes';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { OpenLinkIcon } from 'src/svgs';
import { LockIcon } from 'src/svgs/Viagogo';
import { MarketplacePaymentOptions } from 'src/tables/MarketplacePaymentsTable/Cells/MarketplacePaymentOptionsAction';
import { ContentId } from 'src/utils/constants/contentId';
import { getMarketplacePaymentDetailsModalConfigWithDeepLink } from 'src/utils/marketplacePaymentUtils';
import { Feature, MarketplaceSalePayment } from 'src/WebApiController';

import { MarketplacePaymentsDiscrepancyIcon } from './MarketplacePaymentsDiscrepancyIcon';

interface MarketplacePaymentsActionsCellProps {
  marketplaceSalePayment: MarketplaceSalePayment;
}

export const MarketplacePaymentsActions = ({
  marketplaceSalePayment,
}: MarketplacePaymentsActionsCellProps) => {
  const { setModal } = useContext(ModalContext);

  const hasMarketplacePaymentDiscrepancyFeature = useUserHasFeature(
    Feature.MarketplacePaymentDiscrepancy
  );

  const lockedText = useContent(ContentId.Locked);
  return (
    <>
      <MarketplacePaymentOptions
        marketplaceSalePayment={marketplaceSalePayment}
      />

      <IconButton
        onClick={() =>
          setModal(
            getMarketplacePaymentDetailsModalConfigWithDeepLink(
              marketplaceSalePayment.id
            )
          )
        }
        icon={
          <OpenLinkIcon
            size={vars.iconSize.m}
            fill={vars.color.textBrand}
            withHoverEffect
          />
        }
        titleContentId={ContentId.ViewDetails}
      />
      {marketplaceSalePayment.isLocked && (
        <LockIcon
          size={vars.iconSize.m}
          fill={vars.color.textBrand}
          withHoverEffect
          title={lockedText}
        />
      )}
      {hasMarketplacePaymentDiscrepancyFeature && (
        <MarketplacePaymentsDiscrepancyIcon
          marketplaceSalePayment={marketplaceSalePayment}
        />
      )}
    </>
  );
};
